module.exports = __webpack_public_path__ + "static/media/LogoRemuneraciones.6fee7d16.png";